import React from 'react'
import {  useDispatch,useSelector } from "react-redux";
import Loader from 'Components/Loader';
import { useState } from 'react';
import { useEffect } from 'react';
import api from 'utils/api';
import { message } from 'antd';
import { useHistory } from "react-router-dom";
import { setGuestUUID } from 'store/slice/login-slice';
import { setApiResult } from 'store/slice/dynamic-linking-slice';
import { setUrlParams } from 'store/slice/dynamic-linking-slice';

function DynamicLinking() {
    const [loading,setLoading]=useState(true);
    const dispatch = useDispatch();
    const {dynamiclink} = useSelector((state) => state.dynamiclinkigReducer);
    const history = useHistory();
    useEffect(DynamicApi,[])
    useEffect(CallBack,[dynamiclink])
    function CallBack(){
      if(dynamiclink){
      dispatch(setGuestUUID(dynamiclink?.identifier?.uuid));
      history.push({
        pathname:"/guest-user/funneling-questions" })}
    }
    function DynamicApi(){
    const url = new URL(window.location.href);
    dispatch(setUrlParams(window.location));
    if (url.searchParams.toString() !== "") {
      const payload={
        "url":window.location.href,};
      api
        .dynamic_linking(payload).then((response) => {
          if (response.data?.status === 200) {
            dispatch( setApiResult(response.data?.data));
            sessionStorage.setItem("dynamiclink", true);
          } else {
            message.error(response.data?.message);
          }
        })
        .catch((err) => {
          message.error("Something went wrong");
        })
        .finally(() => {
          setLoading(false);
        });
    }
    else{
      setLoading(false);
    }
  }
  
    return<>{loading?<Loader/>:<></>}</>
}

export default DynamicLinking